import React, { useState } from 'react';
import { amenitiesIcon1, amenitiesImage, minusIcon, plusIcon } from '../assets';
import { amenities } from '../constants';

const Amenities = () => {
  const [expanded, setExpanded] = useState({});

  // Toggle function to expand/collapse the amenity detail
  const toggleExpand = (index) => {
    setExpanded((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="md:px-[100px] px-4 mb-16 flex md:flex-row flex-col md:gap-24 gap-12">
      <div className="md:w-1/2">
        <h2 className="text-[#00A859] font-bold  md:text-3xl text-2xl mb-2">
          Amenities
        </h2>
        <p className="text-[#B2B2B2] font-barlow mb-10">
        At WosAm Luxury Apartments, we offer a range of premium amenities designed to make your stay as comfortable and enjoyable as possible.
        </p>
        <div className="flex flex-col gap-6">
          {amenities.map((item, index) => (
            <div
              key={index}
              className="flex justify-between items-start pb-6 border-b border-[#B2B2B2]"
            >
              <div className="flex gap-6 items-start">
                <img src={item.imageUrl} alt="" />
                <div>
                  <p className="text-[#FF9900] font-barlow mb-2 font-bold">
                  {item.hText}
                  </p>
                  {expanded[index] && (
                    <p className="text-[#B2B2B2] font-barlow font-light md:w-4/5">
                      {item.pText}
                    </p>
                  )}
                </div>
              </div>
              <img
                src={expanded[index] ? minusIcon : plusIcon}
                alt=""
                onClick={() => toggleExpand(index)}
                className="cursor-pointer"
              />
            </div>
          ))}
        </div>
      </div>
      <div className="md:w-1/2">
        <img src={amenitiesImage} alt="" className="mb-6" />
        <p className="text-[#B2B2B2] font-barlow">
        Experience the ultimate in luxury living at Wosam Luxury Apartments. Whether you're here for a day, a month, or longer, we are committed to making your stay unforgettable.
        </p>
      </div>
    </div>
  );
};

export default Amenities;
